import React from 'react';

const NoIncident = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="8" cy="8" r="8" fill="#00A331" />
    <path
      d="M10.9773 5.21725L6.68537 9.20154L5.34559 7.79928C5.01254 7.45064 4.45992 7.43801 4.11128 7.77106C3.76264 8.10412 3.75001 8.65673 4.08306 9.00537L6.0185 11.0314C6.34826 11.3766 6.89412 11.3929 7.2439 11.068L12.1656 6.49656C12.5189 6.16843 12.5393 5.61605 12.2111 5.26277C11.883 4.9095 11.3306 4.88912 10.9773 5.21725Z"
      fill="white"
    />
  </svg>
);

export default NoIncident;
